module.exports = __webpack_public_path__ + "img/diversity@2x.d88d282.jpg";